import { createContext } from 'react'

type LanguageContext = {
  changeLanguage: (s: string) => void
  isActiveLanguage: (s: string) => boolean
}

export const LanguageContext = createContext({} as LanguageContext)
